import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { AmiDatePicker as DatePicker } from '@ami/react/core';
import ShipTo from '../../orders/Shipments/OrderShipToComponent';
import { FormInput } from '@ami/react/core';
import { InvisibleSubmit } from '@ami/react/core';
import { makeValidable } from '@ami/react/core';
import moment from 'moment';
import { OrderShipment } from '@ami/react/shared';
import { NotificationManager } from 'react-notifications';

const FormData = makeValidable(({ shipment, shipmentIndex, save, updateOrderShipment,selectedDealerBranch, showCustomLocation,updateShowCustomLocation }) => {
  return (
    <form className="container" onSubmit={save}>     
     <div className="col-md-12">          
            <label className="form-label">Date</label>           
        </div>   
        <div className="col-md-12">          
        <DatePicker                          
              selected={moment(shipment.shipmentDate)}
              onChange={(shipmentDate) =>
                updateOrderShipment({ shipmentDate })
              }
              filterDate={(date) => {
                return !date.isBefore(moment(), 'day');
              }}
              placeholderText="Enter a ship date"
              required
            />       
       </div>           
        <div className="col-md-12 mt-3">          
        <FormInput
          id="name"
          label="Name"
          value={shipment.name}
          onChange={(e) => updateOrderShipment({ name: e.target.value})    }    
          required      
        />
       </div>          
       <div className="col-md-12 mt-3 ">          
            <label className="form-label">Ship To</label>
            <ShipTo
              location={shipment?.customLocation}
              selectedDealerBranch={selectedDealerBranch}
              showCustomShippingLocation={showCustomLocation}
              onShowCustomShippingLocation={(
                showCustomLocation
              ) => {
                updateShowCustomLocation(showCustomLocation)
              }}
              onLocationChange={(customLocation) =>
                updateOrderShipment({ customLocation })            
              }
            />        
        </div>       
        <div className="col-md-12  mt-3">
              <FormInput
                label="Custom Instructions"
                type="textarea"
                rows={3}
                value={shipment?.customInstruction || ''}     
                onChange={(e) => updateOrderShipment({ customInstruction: e.target.value})    }                         
              />
        </div>
      <InvisibleSubmit />
    </form>
  );
});

export default class OrderShipmentModal extends React.Component {
  constructor(props) {
    super(props);
    this.formDataRef = React.createRef();
  }

  state = {
    show: false,
    showValidations: false,
    shipment: null,
    shipmentIndex : null,
    editMode: false,  
    showCustomLocation : false
  };

  static propTypes = {
    selectedDealerBranch: PropTypes.any,
    shipmmentCount :  PropTypes.int,
    shipments :  PropTypes.array.isRequired,
    onShipmentSave: PropTypes.func.isRequired   
  };
  
  edit(shipment, shipmentIndex) { 
     this.setState({
      show: true,
      showCustomLocation: !!shipment?.customLocation,
      shipment: shipment || new OrderShipment({name : 'Shipment ' + this.props.shipmmentCount, shipmentDate : new Date()}) ,
      shipmentIndex : shipmentIndex,        
      editMode:  !!shipment
    });
  }

  updateOrderShipment = (updateObject) => {        
    this.setState({
      shipment: new OrderShipment({ ...this.state.shipment, ...updateObject })
       });   
  }

  updateShowCustomLocation = (value) => {    
    if(!value) 
      this.updateOrderShipment({ customLocation : undefined})
    this.setState({
      showCustomLocation: value
    });  
  }

  hide = () => this.setState({ show: false });

  save = (e) => {
    if (this.props.shipments.filter(i=>i.name === this.state.shipment.name && i.id !== this.state.shipment.id).length > 0) {
      NotificationManager.error('Please enter a unique shipment name');
      return;
    }  

    if (e) e.preventDefault();
    this.setState({ showValidations: true }, () => {
      if (!this.formDataRef.current.isValid()) return;    
     this.props.onShipmentSave(            
        this.state.shipment,     
        this.state.editMode
      );
      this.hide();
    });
  };

 

  render() {
    if (!this.state.show) return null;

    const shipment = this.state.shipment;  
  
    return (
      <SimpleModal
        show={this.state.show}
        size="sm"
        style={{ maxWidth: '600px', width: '80%' }}
      >
        <ModalHeader title={(this.state.editMode ? "Edit" :"Add") + " Shipment"}/>
        <ModalBody>
          <FormData
            shipment={shipment}
            shipmentIndex ={this.state.shipmentIndex}
            save={this.save}          
            updateOrderShipment={this.updateOrderShipment}
            ref={this.formDataRef}
            selectedDealerBranch= {this.props.selectedDealerBranch}
            showCustomLocation ={this.state.showCustomLocation}         
            updateShowCustomLocation={this.updateShowCustomLocation}
            showValidations={this.state.showValidations}         
          />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={this.save}>
            Save
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
